import { AxiosResponse } from 'axios'
import {
  ApproveRequestProps,
  UploadRegularizationFileProps,
  GetRegularizationForManagerProps,
  downloadRegularizationFileProps,
  GetRegularizationForManagerResponse,
  RejectRequestProps,
} from '../../../../types/TimeAndAttendance/AttendanceRegularization/attendanceRegularizationTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import {
  AllowedHttpMethods,
  attendanceRegularizationApiConfig,
} from '../../apiList'

const getRegularizationForManager = async (
  props: GetRegularizationForManagerProps,
): Promise<GetRegularizationForManagerResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: attendanceRegularizationApiConfig.getRegularizationForManager,
    method: AllowedHttpMethods.get,
    params: {
      startIndex: props?.startIndex,
      endIndex: props?.endIndex,
      managerId: props?.managerId,
      country: props?.country,
      from: props?.from,
      to: props?.to,
      member: props.member || '',
      status: props.status || '',
      type: props?.type,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getApproveRequest = async (
  props: ApproveRequestProps,
): Promise<string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: attendanceRegularizationApiConfig.approveRequest,
    method: AllowedHttpMethods.put,
    params: {
      id: props?.id,
      adminComments: props?.adminComments,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getCancelRequest = async (id: number): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: attendanceRegularizationApiConfig.cancelRequest,
    method: AllowedHttpMethods.put,
    params: {
      id,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getRejectRequest = async (props: RejectRequestProps): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: attendanceRegularizationApiConfig.rejectRequest,
    method: AllowedHttpMethods.put,
    params: {
      id: props?.id,
      comments: props?.comments,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const checkProjectManagerExits = async (id: number): Promise<boolean> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: attendanceRegularizationApiConfig.checkProjectManagerExits,
    method: AllowedHttpMethods.get,
    params: {
      id,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const downloadRegularizationFile = (
  props: downloadRegularizationFileProps,
): Promise<AxiosResponse<Blob>> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: attendanceRegularizationApiConfig.downloadRegularizationFile,
    method: AllowedHttpMethods.get,
    params: {
      date: props?.date,
      empId: props?.empId,
    },
    responseType: 'blob',
    additionalHeaders: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return useAxios(requestConfig) // Full response with headers
}
const uploadRegularizationFile = async (
  props: UploadRegularizationFileProps,
): Promise<Blob | undefined> => {
  const formData = new FormData()

  if (props.file) {
    formData.append('file', props.file)
  }

  const requestConfig = getAuthenticatedRequestConfig({
    url: attendanceRegularizationApiConfig.uploadRegularizationFile,
    method: AllowedHttpMethods.post,
    data: props.file ? formData : undefined, // only send formData if file exists
    params: {
      empId: props.empId,
      date: props.date,
    },
    responseType: 'blob',
    additionalHeaders: {
      'Content-Type': 'multipart/form-data',
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const attendanceRegularizationApi = {
  getRegularizationForManager,
  getApproveRequest,
  getCancelRequest,
  getRejectRequest,
  checkProjectManagerExits,
  downloadRegularizationFile,
  uploadRegularizationFile,
}
export default attendanceRegularizationApi
